import { topicDetailsActionTypes } from './Constants';
import { SOURCE_TYPES } from '../../services/Constants';
import * as topicDetailsActions from './Actions';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { processRequest } from '../../services/Api';
import { relatedQuestionsData } from './Selectors';
import * as errorHandlerActions from '../../components/errorHandler/Actions';

export default function* () {
	yield all([
		takeLatest(topicDetailsActionTypes.GET_TOPIC_DETAILS, handleTopicDetailsRequest),
		takeLatest(
			topicDetailsActionTypes.GET_TOPIC_RELATED_QUESTIONS,
			handleGetRelatedQuestionsRequest,
		),
		takeLatest(topicDetailsActionTypes.GET_TOPIC_EXERCISE, handleGetTopicExerciseRequest),
	]);
}

export function* handleTopicDetailsRequest(action) {
	try {
		const { topicId, source, queries = {} } = action.payload;
		const queriesData = {
			source: source || SOURCE_TYPES.TOPIC,
			...queries,
		};

		const { data } = yield call(processRequest, `public/topics/${topicId}`, 'GET', queriesData);

		yield put(
			topicDetailsActions.getTopicDetailsSuccess({ ...data.topic, no_index: data.no_index }),
		);
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(topicDetailsActions.getTopicDetailsError());
	}
}

export function* handleGetRelatedQuestionsRequest({ payload }) {
	try {
		const { data: queries, topicId } = payload || {};
		const { data } = yield call(
			processRequest,
			`public/topics/${topicId}/qna_questions`,
			'GET',
			queries,
		);

		const formattedData = { results: data.qna_questions, total_count: data.total_count };

		if (queries && queries.offset) {
			const currentData = yield select(relatedQuestionsData);
			formattedData.results = [...currentData.results, ...data.qna_questions];
		}

		yield put(topicDetailsActions.getRelatedQuestionsSuccess(formattedData));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'ignore'));
		yield put(topicDetailsActions.getRelatedQuestionsError());
	}
}

export function* handleGetTopicExerciseRequest({ payload }) {
	const { topic_id, callback } = payload || {};

	try {
		const { data } = yield call(processRequest, `public/topics/${topic_id}/exercise`, 'GET');

		if (callback) callback(data?.exercise_id);
	} catch (e) {
		if (callback) callback(false);
	}
}
